import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)



import Login from '../views/Login.vue'
import NotFound from '../views/404.vue'
import Home from '../views/Home.vue'
import echarts from '../views/charts/echarts.vue'
import Users from '../views/users/users.vue'
import ConsumerUser from '../views/consumer/consumerUser.vue'
import ConsumerCoupon  from '../views/consumer/consumerCoupon.vue'
import BusinessUser  from '../views/business/businessUser.vue'
import OperateUser from '../views/operateManage/operateUser.vue'
import OperaterCoupon from '../views/coupon/operatercoupon.vue'
import businessCoupon from '../views/coupon/businessCoupon.vue'
import CouponCollection from '../views/coupon/couponCollection.vue'
import CouponCheck  from '../views/coupon/couponCheck.vue'
import staff from '../views/business/staffList.vue'
import CouponList from '../views/coupon/couponList.vue'


import Works from '../views/works/works.vue'
import cash from '../views/cash/cash.vue'
import commission from '../views/commission/commission.vue'
import orders from '../views/orders/orders.vue'
import openuser from '../views/works/open.vue'
import content from '../views/Content.vue'
import shareuser from '../views/works/share.vue'
import formuser from '../views/works/form.vue'
import setting from '../views/setting/setting.vue'
import details from "../views/details/details.vue"
import qrcode from "../views/qrcode/QrCode.vue"
import withdrawdata from "../views/finance/withdraw-data.vue"
import rechargedata from "../views/finance/recharge-data.vue"
import basicaccount from "../views/finance/basic-account.vue"
import operate from "../views/finance/operate.vue"
import setaccounts from "../views/finance/set-accounts.vue"
import activity from  "../views/activity/activitys.vue"
import dataanalysis from '../views/qrcode/data-analysis.vue'
import actives from '../views/qrcode/bind-active.vue'
import activeList from '../views/qrcode/binding-actives.vue'
import audit from '../views/qrcode/audit.vue'
import activeBindQrcode from '../views/qrcode/unbind-qrcode.vue'
import randomDraw from '../views/draw/randomDraw.vue'
let routes = [
    {
        path: '/',
        redirect: '/login',
        name: '',
        hidden: true
    },
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '',
        leaf: true,//只有一个节点
        iconCls: 'fa fa-bar-chart',
        children: [
            { path: '/echarts', component: echarts, name: '营销首页' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '营销管理',
        iconCls: 'fa fa-list-alt',//图标样式class
        children: [
            {
                path: '/consumerUser', component: content, name: '用户列表',
                children: [
                    { path: '/', component: ConsumerUser,},
                    { path: '/consumerUser/details', component: content, name: '账户明细',
                        children: [
                            {path: '/', component: details,},
                        ]
                    },
                    { path: '/consumerUser/works', component: content, name: '作品列表',
                        children: [
                            { path: '/', component: Works,},
                            { path: '/consumerUser/works/open', component: openuser, name: '传播客户'},
                            { path: '/consumerUser/works/share', component: shareuser, name: '转发客户'},
                            { path: '/consumerUser/works/form', component: formuser, name: '表单客户'},
                        ]
                        
                    },{
                        path: '/consumerUser/coupon', component: content, name: '卡券库',
                        children: [
                            { path: '/', component: ConsumerCoupon,},
                            { path: '/consumerUser/coupon/operateCouponCollection', component: CouponCollection, name: '领取记录'},
                            { path: '/consumerUser/coupon/operateCouponCheck', component: CouponCheck, name: '核销记录'}
                        ]
                    }
                ]
            },
            {
                path: '/businessUser', component: content, name: '商户管理',
                children: [
                    { path: '/', component: BusinessUser,},
                    { path: '/businessUser/details', component: content, name: '账户明细',
                        children: [
                            {path: '/', component: details,},
                        ]
                    },
                    { path: '/businessUser/works', component: content, name: '作品列表',
                        children: [
                            { path: '/', component: Works,},
                            { path: '/businessUser/works/open', component: openuser, name: '传播客户'},
                            { path: '/businessUser/works/share', component: shareuser, name: '转发客户'},
                            { path: '/businessUser/works/form', component: formuser, name: '表单客户'},
                        ]
                        
                    },{
                        path: '/businessUser/coupon', component: content, name: '卡券库',
                        children: [
                            { path: '/', component: businessCoupon,},
                            { path: '/businessUser/coupon/operateCouponCollection', component: CouponCollection, name: '领取记录'},
                            { path: '/businessUser/coupon/operateCouponCheck', component: CouponCheck, name: '核销记录'}
                        ]
                    },
                    { path: '/businessUser/staff', component: content, name: '商户员工',
                        children: [
                            {path: '/', component: staff,},
                        ]
                    },
                    { path: '/businessUser/staff', component: content, name: '商户员工',
                        children: [
                            {path: '/', component: staff,},
                        ]
                    }, 
                    { path: '/businessUser/OperateUser', component: content, name: '商户员工认证',
                        children: [
                            {path: '/', component: OperateUser,},
                        ]
                    },
                ]
            },
            {
                path: '/operateManage', component: content, name: '运营管理',
                children: [
                    { path: '/', component: OperateUser,},
                    { path: '/operateManage/details', component: content, name: '账户明细',
                        children: [
                            {path: '/', component: details,},
                        ]
                    },
                    { path: '/operateManage/works', component: content, name: '作品列表',
                        children: [
                            { path: '/', component: Works,},
                            { path: '/operateManage/works/open', component: openuser, name: '传播客户'},
                            { path: '/operateManage/works/share', component: shareuser, name: '转发客户'},
                            { path: '/operateManage/works/form', component: formuser, name: '表单客户'},
                        ]
                        
                    },{
                        path: '/operateManage/coupon', component: content, name: '卡券库',
                        children: [
                            { path: '/', component: OperaterCoupon,},
                            { path: '/operateManage/coupon/operateCouponCollection', component: CouponCollection, name: '领取记录'},
                            { path: '/operateManage/coupon/operateCouponCheck', component: CouponCheck, name: '核销记录'}
                        ]
                    }
                ]
            },
            {
                path: '/couponList', component: content, name: '卡券管理',
                children: [
                    { path: '/', component: CouponList},
                    { path: '/couponList/getCouponCollection', component: CouponCollection, name: '领取记录'},
                    { path: '/couponList/checkCoupon', component: CouponCheck, name: '核销记录'}

                ]
            },
            // {
            //     path: '/users', component: content, name: '用户列表',
            //     children: [
            //         { path: '/users', component: Users,},
            //         { path: '/users/details', component: content, name: '账户明细',
            //             children: [
            //                 {path: '/users/details', component: details,},
            //             ]
            //         },
            //         { path: '/users/works', component: content, name: '作品列表',
            //         children: [
            //             { path: '/users/works', component: Works,},
            //             { path: '/users/works/open', component: openuser, name: '传播客户'},
            //             { path: '/users/works/share', component: shareuser, name: '转发客户'},
            //             { path: '/users/works/form', component: formuser, name: '表单客户'},
            //         ]
            //         },
            //     ]
            // },
            {
                path: '/works', component: content, name: '作品列表',
                children: [
                    { path: '/works', component: Works,},
                    { path: '/works/open', component: openuser, name: '传播客户'},
                    { path: '/works/share', component: shareuser, name: '转发客户'},
                    { path: '/works/form', component: formuser, name: '表单客户'},
                    { path: '/works/qrcodes',component: activeBindQrcode, name: '已绑定二维码列表'},
                ]
            },
            {
                path: '/draw', component: content, name: '随机抽奖',
                children: [
                    { path: '/', component: randomDraw,},
                    { path: '/draw/randomDraw/operateCouponCollection', component: CouponCollection, name: '领取记录'},
                    { path: '/draw/randomDraw/operateCouponCheck', component: CouponCheck, name: '核销记录'}
                ]
            }
        
            // { path: '/form', component: Form, name: 'Form' },
            // { path: '/user', component: user, name: '列表' },
        ]
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '营销管理',
    //     hidden: true,
    //     iconCls: 'el-icon-message',//图标样式class
    //     children: [
    //                 { path: '/works/open', component: openuser, name: '传播客户'},
    //                 { path: '/works/share', component: Form, name: '转发客户'},
    //                 { path: '/works/form', component: user, name: '表单客户'},
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '导航二',
    //     iconCls: 'fa fa-id-card-o',
    //     children: [
    //         { path: '/page4', component: Page4, name: '页面4' },
    //         { path: '/page5', component: Page5, name: '页面5' }
    //     ]
    // },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-money',
        leaf: true,//只有一个节点
        children: [
            { path: '/cash', component: cash, name: '提现管理' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-credit-card',
        leaf: true,//只有一个节点
        children: [
            { path: '/commission', component: commission, name: '抽佣管理' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-indent',
        leaf: true,//只有一个节点
        children: [
            { path: '/orders', component: orders, name: '订单管理' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-user-circle',
        leaf: true,//只有一个节点
        children: [
            { path: '/setting', component: setting, name: '账号管理' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '财务报表',
        iconCls: 'fa fa-line-chart',
        children: [
                {path: '/withdrawdata', component: withdrawdata, name: '红包及提现数据'},
                {path: '/rechargedata', component: rechargedata, name: '管理台免费充值表'},
                {path: '/basicaccount', component: basicaccount, name: '微信支付-基本账户'},
                {path: '/operate', component: operate, name: '微信支付-运营账户'},
                {path: '/setaccounts', component: setaccounts, name: '微信支付-结算表'}
        ]
    },
    {
        path: '/',
        component: Home,
        name: '二维码',
        iconCls: 'fa fa-qrcode',
        children: [
            {
                path: '/audit', component: content, name: '二维码审核',
                children: [
                    { path: '/audit', component: audit,},
                    {path: '/audit/addAactive', component: activeList, name: '添加活动'}
                ]
            },
            { path: '/qrcode', component: content, name: '二维码管理',
                children: [
                    { path: '/qrcode', component: qrcode,},
                    { path: '/qrcode/dataanalysis', component: dataanalysis, name: '数据分析'},
                    { path: '/qrcode/activelist', component: actives, name: '活动列表'},
                    { path: '/qrcode/addAactive', component: activeList, name: '添加活动'},
                ]
            }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-flag-checkered',
        leaf: true,//只有一个节点
        children: [
            { path: '/activity', component: activity, name: '大学生活动' }
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

const router = new Router({
    mode: 'history',
    routes
})


Router.prototype.beforeInterceptors = [];

Router.prototype.addBeforeInterceptor = function (interceptor) {
    this.beforeInterceptors.push(interceptor)
};

// eslint-disable-next-line no-unused-vars
Router.prototype.beforeEachGuard = async function (to, from, next) {
    console.log(to, from)
    for (const interceptor of this.beforeInterceptors) {
        const result = await interceptor(to, from, next);
        if (result) {
            return true
        }
    }
    next()
};
// eslint-disable-next-line no-unused-vars
router.beforeEach(async (to, from, next) => {
    await router.beforeEachGuard(to, from, next)
});
export default router

